export default __webpack_public_path__ + "static/media/1.1cad47e7.jpg";